import { styled } from 'styled-components';
import { QRCode } from 'components/Base/QRCode';

export const SQRCode = styled(QRCode)`
  && {
    border: 0;
  }
`;
